<template>
  <div>
    <el-form :model="form">
      <el-form-item label="文章描述" :label-width="formLabelWidth">
        <vue-editor v-model="form.description"
                    useCustomImageHandler
                    @imageAdded="this.$common.handleImageAdded">
        </vue-editor>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit()">提交</el-button>
    </div>
  </div>
</template>

<script>
  import { VueEditor } from 'vue2-editor'
  export default {
    name: "Cooperation",
    components: {
      VueEditor
    },
    data() {
      return {
        form: {},
        formLabelWidth: '120px',
        common: this.$common,
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.loadData();
      })
    },

    methods:{
      loadData() {
        this.common.post('content/list', {
            'type': 'cooperation',
          }, (response) => {
            if(response.data.content && response.data.content.length>0){
              this.form = response.data.content[0]
            }
          }
        )
      },
      submit() {
        const self = this
        this.form.type='cooperation'
        let postData = self.$qs.stringify(this.form)
        let method = 'save'
        if (self.form.id) {
          method = 'update'
        }
        self.$http.post(self.$host + 'content/' + method,
          postData
        ).then(function (response) {
          self.$common.loginCheck(response.data.content)
          self.successMsg();
        }).catch(e => {
          console.log(e)
        })
      },
      successMsg() {
        this.$message({
          message: '保存成功',
          type: 'success'
        });
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/manage/Cooperation.vue